import { Drawer } from 'antd';
import { translateDay } from 'features/schedule/utils';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import { AppText } from 'shared/UI/UIKit/Text';
import { AppLockOnIcon } from 'shared/UI/UIKit/icons/LockOn';
import { AppTooltip } from 'shared/UI/UIKit/Tooltip';
import { educationParallelTextRepresentation } from 'entities/education-class';
import { getContsraintTag } from 'features/schedule/utils/getContsraintTag';
import { AppUsersGroupIcon } from 'shared/UI/UIKit/icons/UsersGroup';
import type { DayOfWeek } from 'services/api';
import { useLessonDetails } from '../model';

export const LessonDetails = () => {
  const {
    state: { selectedLesson },
    methods: { handleCloseLessonDetails },
  } = useLessonDetails();

  const { lesson, slotKey, detailOpen } = selectedLesson || {};

  if (!lesson || !slotKey || detailOpen === false) return null;

  const [dayOfWeek, startTime, endTime] = slotKey.split('-') as [DayOfWeek, string, string];

  return (
    <Drawer
      open={Boolean(selectedLesson)}
      placement="bottom"
      destroyOnClose
      onClose={handleCloseLessonDetails}
      maskStyle={{ backgroundColor: 'rgba(0, 0, 0, 0)' }}
      title={
        <AppFlex direction="row" alignItems="center" justifyContent="flex-start">
          <AppText>{lesson.subject.name}</AppText>
          {lesson?.pinned && (
            <AppTooltip title={'Урок закреплен'}>
              <AppLockOnIcon />
            </AppTooltip>
          )}

          {lesson?.group && (
            <AppTooltip title={'Урок по группам'}>
              <AppUsersGroupIcon />
            </AppTooltip>
          )}
        </AppFlex>
      }
      height={280}
    >
      <AppFlex direction="column" unit="16">
        <AppFlex direction="row" alignItems="center" justifyContent="flex-start" unit="20">
          {selectedLesson?.errors?.map((error, i) => (
            <span key={error?.code ?? i}>{getContsraintTag(error?.code, error?.category)}</span>
          ))}
        </AppFlex>
        <AppFlex direction="row" alignItems="center" justifyContent="flex-start" unit="20">
          <AppFlex direction="column" unit="8">
            <span>Преподаватель: {lesson.teacher.code.split(' - ')[0]}</span>
            <span>Кабинет: {lesson.room.name}</span>
            <span>День: {translateDay(dayOfWeek)}</span>
            <span>
              Время: {startTime} {endTime}
            </span>
            <span>
              Класс:{' '}
              {selectedLesson?.educationalClass
                ? `${
                    educationParallelTextRepresentation[selectedLesson?.educationalClass?.parallel]
                  }${selectedLesson?.educationalClass?.litera}`
                : ''}
            </span>
            {lesson?.group && <span>Группа: {`${lesson.group.name}`}</span>}
          </AppFlex>
        </AppFlex>
      </AppFlex>
    </Drawer>
  );
};
